import React, { useEffect } from 'react';
import { CenterModal } from 'react-spring-modal';
import { useRecoilState } from 'recoil';
import closebtn from '../../assets/icons/closebtn.svg';
import { BoxDetailModalOpen } from '../../recoil-states/user-state/user-state';
import '../../css/BoxDetailModal.css';
import DescriptionInner from './DescriptionInner';
import Share from '../../assets/share.png';
import { isMobile } from 'react-device-detect';
import { motion } from 'framer-motion';

export default function BoxDetailModal({ textData, img, onClick, DumanData }) {
	const [isOpen, setIsOpen] = useRecoilState(BoxDetailModalOpen);
	const titleImage = img ?? require('../../assets/mintingCard.png');
	return (
		<>
			<CenterModal
				isOpen={isOpen}
				onDismiss={() => {
					setIsOpen(false);
				}}
				contentTransition={{
					from: { transform: 'translateY(0)' },
					enter: { transform: 'translateY(0)' },
					leave: { transform: 'translateY(0)' },
				}}
				contentProps={{ style: staticModalStyles }}
			>
				<motion.div
					className='boxdetail-container'
					initial={{
						opacity: 0,
						scale: 0.75,
					}}
					animate={{
						opacity: 1,
						scale: 1,
						transition: {
							ease: 'easeOut',
							duration: 0.15,
						},
					}}
					exit={{
						opacity: 0,
						scale: 0.75,
						transition: {
							ease: 'easeIn',
							duration: 0.15,
						},
					}}
				>
					<div className='boxdetail-header'>
						<button
							onClick={() => {
								setIsOpen(false);
							}}
						>
							<img src={closebtn} alt='close button' />
						</button>
					</div>
					<div className='boxdetail-inner-container'>
						<div className='boxdetail-img-container'>
							<img src={titleImage} alt='Card detail' />
						</div>
						<div className='boxdetail-sub-box'>
							<div className='boxdetail-sub-box-left'>
								<p>
									<b>Konnect World</b>
								</p>
							</div>
							<div className='boxdetail-sub-box-right'>
								<p>
									Owned by <b>Konnect</b>
								</p>
								<img src={Share} />
							</div>
						</div>
						<div className='boxdetail-title-box'>
							<p className='boxdetail-title'>
								Konnect
								<br />
								DUMAN PFP Pack
							</p>
							<p className='boxdetail-title'>#001</p>
						</div>
						<DescriptionInner
							DumanData={DumanData}
							onClick={onClick}
							textData={textData}
							img={img}
						/>
					</div>
				</motion.div>
			</CenterModal>
		</>
	);
}

const staticModalStyles = {
	minWidth: isMobile || window.innerWidth <= 1200 ? '90%' : '40%',
	height: '80%',
	padding: '20px',
	borderRadius: '1rem',
	background: '#000',
	border: '1px solid #000',
	animation: 'none',
	overflow: 'hidden',
};
